import React from 'react';

import { applicationTitles } from '../../localization/en-us/applicationTitles';

import classes from './Title.module.css';

const architect = props => {
    return (
        <div className={classes.TitleBox}>
            <img src="/assets/images/architectColorIcon.svg" alt="architect" />
            <p>{applicationTitles.architect}</p>
        </div>
    );
};

export default architect;
